<div class="view-columns">
    <div class="view-columns__inner" [ngClass]="{'-vertical-center': verticalCenter}">

        <div class="view-columns__col -for-left" [ngClass]="{'-vertical-center': verticalCenterLeft}" *ngIf="left">
            <ng-container *ngTemplateOutlet="left"></ng-container>

        </div>

        <div class="view-columns__col -for-right" [ngClass]="{'-vertical-center': verticalCenterRight}" *ngIf="right">
            <ng-container *ngTemplateOutlet="right"></ng-container>
        </div>

    </div>
</div>